import React, { useEffect, useState } from "react";

const KEY = "aoc_ack_session";

export default function AcknowledgementModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Show the acknowledgement immediately, before any other render flash.
    if (!sessionStorage.getItem(KEY)) setOpen(true);
  }, []);

  const accept = () => {
    sessionStorage.setItem(KEY, new Date().toISOString());
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      data-testid="acknowledgement-modal"
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-[#2D2926]/50 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="aoc-title"
    >
      <div className="relative max-w-2xl w-full bg-[#F8F5F2] border border-[#E3DDD7] shadow-2xl">
        <div
          className="absolute inset-x-0 top-0 h-1.5"
          style={{
            background:
              "linear-gradient(to right, #2D2926 0%, #2D2926 33%, #E25C46 33%, #E25C46 66%, #D39E6D 66%, #D39E6D 100%)",
          }}
        />
        <div className="px-8 md:px-12 py-12 md:py-14">
          <p className="label-eyebrow text-[#E25C46]" id="aoc-title">
            Acknowledgement of Country
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-light text-[#2D2926] mt-5 leading-tight tracking-tight">
            We walk softly on this land.
          </h2>
          <div className="mt-8 space-y-4 text-[#5B5653] leading-relaxed text-base">
            <p>
              Colleen Prosser Art acknowledges the Traditional Custodians of the lands on which
              we live, create, and trade. We pay our respects to Elders past and present, and
              extend that respect to all Aboriginal and Torres Strait Islander peoples who
              continue to care for Country.
            </p>
            <p>
              Each work in this collection carries a story from Country. We invite you to view
              these paintings with the care and respect they hold.
            </p>
          </div>
          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-end">
            <button
              data-testid="aoc-accept-btn"
              onClick={accept}
              className="btn-primary"
            >
              Enter the Gallery
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
